






















































































































































































































































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class EnglishSkills extends Vue {
  private showTimeline = 0;

  private cvFirst = [
    {
      name: 'Name:',
      val: 'Jeet Ajaybhai Mandaliya',
    },
    {
      name: 'Nationality:',
      val: 'Indian',
    },
    {
      name: 'Gender:',
      val: 'Male',
    },
    {
      name: 'Email:',
      val: '<a target="_blank" href="mailto:jeet.mandaliya7@gmail.com">jeet.mandaliya7@gmail.com</a>',
    },
  ];

  private headers = [
    {
      text: 'Language',
      align: 'start',
      value: 'name',
    },
    { text: 'Listening', value: 'hearing', align: 'center' },
    { text: 'Reading', value: 'reading', align: 'center' },
    { text: 'Coherent Speaking', value: 'zspeaking', align: 'center' },
    { text: 'Participating in Discussions', value: 'protein', align: 'center' },
    { text: 'Writing', value: 'write', align: 'center' },
  ];

  private desserts = [
    {
      name: 'HINDI',
      hearing: 'C2',
      reading: 'C2',
      zspeaking: 'C1',
      protein: 'C1',
      write: 'C1',
    },
    {
      name: 'ENGLISH',
      hearing: 'C1',
      reading: 'C1',
      zspeaking: 'C1',
      protein: 'C1',
      write: 'C1',
    },
    {
      name: 'GERMAN',
      hearing: 'C1',
      reading: 'C1',
      zspeaking: 'C1',
      protein: 'C1',
      write: 'C1',
    },
  ];

  private years = [
    {
      color: 'cyan',
      year: '11<sup>th</sup> September 2000',
      title: 'Birth',
    },
    {
      color: 'green',
      year: '2006',
      title: 'First Step in Education',
      disc: 'New Era Primary-School, Rajkot, Gujarat',
    },
    {
      color: 'pink',
      year: '2012',
      title: 'Diving into Web-Dev',
      disc: 'Got introduced to the world of Front-End Web-Dev with HTML & CSS.',
    },
    {
      color: 'amber',
      year: '2015 - 2016',
      title: 'Milestone: 10<sup>th</sup> Class',
      disc: 'State 3<sup>rd</sup> with Average Score of 94.5% and 99.97PR(Percentile Rank)',
    },
    {
      color: 'orange',
      year: '2016 - 2018',
      title: 'Milestone: 12<sup>th</sup> Class',
      disc: '<ul> <li data-aos="fade-left"> Major Subjects: Mathematics, Physics and Chemistry. </li> <li data-aos="fade-left"> Average Score: 87.54% and 98.83PR. </li> <li data-aos="fade-left">Grades as per German Grading System: 2.2. </li> </ul><br/>',
    },
    {
      color: 'cyan',
      year: 'June 2018 - Dec 2018',
      title: 'Preparation: IELTS Exam and German Exams(A1-A2 Level)',
      disc: `<ul>
          <li data-aos="fade-right"> German A1 Level Preparation and Exam at Goethe Zentrum, Ahmadabad (with 94%). </li>
          <li data-aos="fade-right"> IELTS Preparation and Exam in October 2018 (with 7.0 Bands and CEFR Level C1). </li>
        </ul>`,
    },
    {
      color: 'green',
      year: 'Aug 2018',
      title: 'Started learning Full-Stack Web-Dev',
      disc: 'Encountered the whole new world of creating stunning web applications with NodeJS, ExpressJS, MongoDB and Mongoose with EJS templating.',
    },
    {
      color: 'pink',
      year: 'Jan 2019 - Jun 2019',
      title: 'German Language Course',
      disc: 'From A2 to B2 Level, I brushed up my german skills in GLS - German Language School, Berlin. <br/><ul><li> Telc B2 Examination, May 2019 with 263 Points out of 300. </li></ul>',
    },
    {
      color: 'amber',
      year: 'Jun 2019',
      title: 'First Large-Scale Web-Dev Event',
      disc: 'Volunteer at WeAreDevelopers World-Congress, June 2019, Berlin.',
    },
    {
      color: 'orange',
      year: 'Aug 2019',
      title: 'Beginning of Studienkolleg @ TU Berlin',
      disc: 'T - Course (Technical Course): <ul> <li data-aos="fade-right">Core Subjects: German, Mathematics, Physics. </li><li data-aos="fade-right">Minor Subjects: Chemistry, Informatics. </li> </ul> ',
    },
    {
      color: 'cyan',
      year: 'Oct 2019 - present',
      title: 'Initial Work Experience',
      disc: `Working-Student - Frontend Developer @ Rosenmeister LegalTech GmbH(later Legislayer GmbH), Berlin <br/> <br/>
        <div data-aos="fade-left">
        Tasks: </div>
        <ul>
          <li data-aos="fade-left"> Management, Testing(Unit and E2E) and Enhancement of the Hyperbot(SaaS) made for Lawyers for digital Case Processing. </li>
          <li data-aos="fade-left"> Implementation of GitHub Action, AWS Codebuild Actions and Pre-Commit-Hooks for an optimized workflow. </li>
          <li data-aos="fade-left"> Automatization of Data-Import using Zapier Applications (built with NodeJS). </li>
        </ul>
        `,
    },
    {
      color: 'green',
      year: 'June 2020',
      title: 'Final Assessment Exams in Studienkolleg',
      disc: `
          Average Grade: 1.4
        `,
    },
    {
      color: 'pink',
      year: 'Oct 2020',
      title: 'B.Sc. Computer Science at TU Berlin',
      disc: `
          Currently in 3<sup>rd</sup> semester
        `,
    },
    // {
    //   color: 'amber',
    //   year: 'Since Always',
    //   title: 'My Goals',
    //   disc: `
    //       <ul>
    //         <li data-aos="fade-left"> Graduate from TU Berlin as a Computer Scientist. </li>
    //         <li data-aos="fade-left"> Become a Full-Stack Web-Engineer. </li>
    //       </ul>
    //     `,
    // },
  ].reverse();

  get showCv(): boolean {
    return !!this.$route.name?.includes('cv');
  }
}
